import { Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";

const InputList = ({ title, values, onChange, inputPlaceholder, inputType }) => {
  const addInput = () => {
    onChange([...values, ""]);
  };

  const removeInput = (index) => {
    const listUpdated = [...values];
    listUpdated.splice(index, 1);
    onChange(listUpdated);
  };

  const onChangeInput = (index, value) => {
    const listUpdated = [...values];
    listUpdated[index] = value;
    onChange(listUpdated);
  };

  return (
    <>
      <Flex alignItems="center">
        <div className="fs-5">{title}</div>
        <div style={styles.iconAction} onClick={addInput}>
          <AddCircleOutline color="action" />
        </div>
      </Flex>
      {values?.length > 0 && (
        <Grid paddingLeft="10px">
          <Flex wrap="wrap" columnGap={30} rowGap={15}>
            {values?.map((item, index) => (
              <Flex key={index} alignItems="center">
                <TextField
                  type={inputType}
                  required
                  placeholder={inputPlaceholder}
                  value={item}
                  onChange={(event) => onChangeInput(index, event.target.value)}
                />
                <div
                  style={styles.iconAction}
                  onClick={() => removeInput(index)}
                >
                  <RemoveCircleOutline color="action" />
                </div>
              </Flex>
            ))}
          </Flex>
        </Grid>
      )}
    </>
  );
};

const styles = {
  iconAction: {
    marginLeft: "-5px",
    marginTop: "5px",
    cursor: "pointer",
  },
};

export default InputList;
